import React, { useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import { ButtonEduk, themes } from "@mindlab-org/component-library";
import "./CustomHeader.sass";
import * as routes from "../../routes/routes";
import { actions } from "../../redux/actions/actions";
import clearSiteData from "../../utils/Authentication/clearSiteData";
import { routesEduk } from "../../routes/routesEduk";
import { menuItems } from "./menuItems";
import { Logo } from "../Logo";
import { DropdownHeader } from "./components/DropdownHeader";

export const CustomHeader = ({
  authorizationUnset,
  history,
  isAuth,
  goBack,
  routeGoBack,
  blockMenu,
}) => {
  const [menuIsOpen, setMenuIsOpen] = useState(false);
  const onClickLogo = () => window.open(routes.HEADER_EDUK_LINK);

  const onClickLogout = () => {
    authorizationUnset();
    clearSiteData();
  };

  const menuConfig = isAuth
    ? []
    : [
        <ButtonEduk
          key={1}
          retangular
          backgroundColor="#F35843"
          onButtonClick={() => window.open(routesEduk.register, "_self")}
          hoverColor={"#F35843"}
        >
          Criar conta
        </ButtonEduk>,
        <div>
          <hr />
          ou
          <hr />
        </div>,
        <ButtonEduk
          key={2}
          retangular
          backgroundColor={"transparent"}
          onButtonClick={() => window.open(routesEduk.login, "_self")}
          hoverColor={"transparent"}
          textColor="#F35843"
          borderColor="#F35843"
        >
          Entrar
        </ButtonEduk>,
      ];

  return (
    <>
      <header className="CustomHeader">
        <div className="CustomHeader__Container">
          <button
            type="button"
            class="MenuButton"
            onClick={() => setMenuIsOpen(!menuIsOpen)}
          >
            <svg
              stroke="currentColor"
              fill="currentColor"
              stroke-width="0"
              viewBox="0 0 16 16"
              height="32"
              width="32"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z"
              ></path>
            </svg>
          </button>
          <Logo onClick={onClickLogo}/>
          <div />
        </div>
      </header>
      <section className="Menu" data-is-open={menuIsOpen}>
        <div
          className="Shadow"
          data-is-open={menuIsOpen}
          onClick={() => setMenuIsOpen(false)}
        />
        <div className="Menu__Drawer" data-is-open={menuIsOpen}>
          <div className="Menu__Header">
            <Logo onClick={onClickLogo}/>
            <button
              className="Menu__CloseButton"
              onClick={() => setMenuIsOpen(false)}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                height="24"
                viewBox="0 0 24 24"
                width="25px"
              >
                <path
                  d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
                  fill="#333333"
                ></path>
                <path d="M0 0h24v24H0z" fill="none"></path>
              </svg>
            </button>
          </div>
          <div className="Menu__Items">
            {menuItems({ onClickLogout, isAuth }).map((item) => {
              if (item.dropdown)
                return (
                  <DropdownHeader text={item.text} dropItems={item.dropItems} />
                );

              return <button onClick={item.func}>{item.text}</button>;
            })}
          </div>
          <div className="Menu__Auth">{menuConfig.map((item) => item)}</div>
        </div>
      </section>
    </>
  );
};

CustomHeader.propTypes = {
  authorizationUnset: PropTypes.func,
  blockMenu: PropTypes.bool,
  history: PropTypes.any,
  isAuth: PropTypes.bool,
};

CustomHeader.defaultProps = {
  isAuth: false,
  blockActions: false,
};

const mapStateToProps = (state) => ({
  isAuth: state.authorization.isAuth,
});

const mapDispatchToProps = (dispatch) => ({
  authorizationUnset: () => dispatch(actions.authorizationUnset()),
});

export default connect(mapStateToProps, mapDispatchToProps)(CustomHeader);
